export { default } from "./RowHeading";
